export default __webpack_public_path__ + "static/media/jobfeed-icon.b37bb380.svg";